import '$lib/i18n';
import { locale as lang, waitLocale } from 'svelte-i18n';

export const prerender = false;

// @ts-ignore
export const load = async ({ url, data }) => {
    const locale = url.pathname.split('/')[1] || 'en';

    lang.set(locale);

    // Tunggu sampai bahasa siap
    await waitLocale();

    return {
        ...data,
        locale,
    };
};
